<template>
  <transition name="slide">
    <div class="setup" v-if="setupVisible">
      <div class="setup__list">
        <h3>Your setup:</h3>
        <div
          class="setup__item"
          v-for="part in parts"
          :key="part.id"
          v-if="configuration.indexOf(part.id) !== -1"
        >
          <img
            :src="`/static/images/thumbnails/${part.thumbnail}`"
            class="setup__item-image"
            v-if="part.thumbnail"
          />
          <div class="setup__item-content">
            <h4 class="setup__item-title">{{part.name}}</h4>
            <p class="setup__item-description">{{part.description}}</p>
          </div>
        </div>
      </div>
      <div class="setup__specs">
        <h3>Technical specifications</h3>
        <ul class="setup__specs-list">
          <li class="setup__specs-item" v-for="item in spec" :key="item.name">
            <div class="setup__specs-name" v-html="item.name"></div>
            <div class="setup__specs-value"
              v-if="!Array.isArray(item.value)"
              v-html="item.value"></div>
            <ul v-else class="setup__specs-sublist">
              <li class="setup__specs-item" v-for="subitem in item.value" :key="subitem.name">
                <div class="setup__specs-name setup__specs-name--sub" v-html="subitem.name"></div>
                <div class="setup__specs-value" v-html="subitem.value"></div>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  computed: {
    ...mapState(['parts', 'configuration', 'setupVisible', 'spec']),
  },
  methods: {
    ...mapActions(['hideSetup']),
    windowClickHandler(ev) {
      if (!ev.target.closest('.setup') && !ev.target.closest('.conf-nav')) {
        this.hideSetup();
      }
    },
  },
  mounted() {
    window.addEventListener('click', this.windowClickHandler);
  },
  beforeDestroy() {
    window.removeEventListener('click', this.windowClickHandler);
  },
};
</script>


<style lang="scss">
@import '../styles/helpers';

.slide-enter-active, .slide-leave-active {
  transition: transform .4s;
}
.slide-enter, .slide-leave-to /* .slide-leave-active below version 2.1.8 */ {
  transform: translateX(100%);
}

.setup {
  background: #fff;
  padding-top: 100px;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 60px;
  width: 430px;
  overflow-y: auto;
  box-shadow: -3px 0 8px 0 rgba($c_black, .1);

  &:after {
    content: '';
    display: block;
    background: #F2F2F2;
    position: fixed;
    top: 0;
    right: 0;
    height: 100px;
    width: 430px;
  }

  h3 {
    font-size: 18px;
    font-weight: 500;
    margin: 0 0 40px;
  }

  &__list {
    width: 100%;
    box-sizing: border-box;
    padding: 40px;
  }

  &__item {
    display: flex;
    align-items: flex-start;
    padding: 0 0 40px;
    border-bottom: 1px solid #D4D4D4;
    margin-bottom: 40px;

    &:last-child {
      margin-bottom: 0;
      padding-bottom: 0;
      border-bottom: 0;
    }
  }

  &__item-title {
    margin: 0 0 1em;
    font-weight: 500;
  }

  &__item-description {
    margin: 0;
    font-weight: 300;
  }

  &__item-image {
    width: 71px;
    height: auto;
    margin: 0 20px 0 0;
    flex-shrink: 0;
  }

  &__specs {
    background: #FFF0C8;
    padding: 40px;
  }

  &__specs-list {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  &__specs-item {
    display: flex;
    margin-bottom: 15px;
    flex-wrap: wrap;

    &:last-child {
      margin-bottom: 0;
    }
  }

  &__specs-name {
    width: 50%;
    &--sub {
      padding-left: 12px;
      box-sizing: border-box;
    }
  }

  &__specs-value {
    width: 50%;
    flex-grow: 0;
    font-weight: $t_light;
  }

  &__specs-sublist {
    margin: 15px 0 0;
    padding: 0;
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Setup.vue